export interface CancelSubscriptionDialogData {
	productTitle: string;
}

export interface CancelSubscriptionFeedback {
	stars_count: number | null;
	reason_to_cancel: string | null;
	will_return: 'Yes' | 'No' | null;
	suggestion: string | null;
}

export interface CancelSubscriptionDialogResult {
	confirmed: boolean;
	feedback?: CancelSubscriptionFeedback;
}

/** Fixed reason list shown in the cancellation dialog. */
export const CANCELLATION_REASONS: string[] = [
	'Found a better alternative',
	'Cost-related issues',
	'Not satisfied with service',
	'No longer needed',
	'Technical Issues',
	'Other'
];
